import React, {useEffect, useRef} from "react";


import "./StartScreen.css";

type StartScreenProps = {
    predictCanvas: (canvas: HTMLCanvasElement) => void;
    image: File;
    setImageFile: (image: File | null) => void;
}

// Component for displaying our selected image file for prediction
function StartScreen() {

    const canvas = useRef<HTMLCanvasElement>(null);
    const display = useRef<HTMLDivElement>(null);

 

    return (
        <div className = 'start-screen'>
            <div className = 'center-modal'>
            <h1>Add a photo</h1>
            </div>
        </div>
    )
}

export default StartScreen;
